// Collections megamenu text transformation
document.addEventListener('DOMContentLoaded', function() {
  function applyCollectionsUppercase() {
    // Find all megamenu items
    const megamenus = document.querySelectorAll('.mega-menu');
    
    megamenus.forEach(function(megamenu) {
      // Find the summary/trigger element
      const summary = megamenu.querySelector('summary');
      if (!summary) return;
      
      // Check if the summary text contains "Collections" (case insensitive)
      const summaryText = summary.textContent.trim().toLowerCase();
      if (summaryText.includes('collections')) {
        // Find all dropdown links in this megamenu
        const dropdownLinks = megamenu.querySelectorAll('.mega-menu__link');
        
        // Apply uppercase styling to each link
        dropdownLinks.forEach(function(link) {
          link.style.textTransform = 'uppercase';
        });
      }
    });
  }
  
  // Apply on initial load
  applyCollectionsUppercase();
  
  // Also apply when megamenu opens (in case of dynamic content)
  document.addEventListener('click', function(event) {
    if (event.target.closest('summary')) {
      setTimeout(applyCollectionsUppercase, 50);
    }
  });
});